import { Icon, ICONS } from 'components/Icon';

import { theme } from 'lib/theme';
import React from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';

import { FIELD_ICON_SIZE } from 'types/types';

interface Props {
  icon: ICONS;
  style?: StyleProp<ViewStyle>;
  iconSize?: number;
  iconColor?: string;
}

export const FieldTypeIcon: React.FC<Props> = ({
  icon,
  iconSize,
  iconColor,
  style,
}) => (
  <View
    style={[
      {
        width: 36,
        alignItems: 'center',
        justifyContent: 'center',
      },
      style,
    ]}
  >
    <Icon
      source={icon}
      size={iconSize || FIELD_ICON_SIZE}
      color={iconColor || theme.colors.placeholder}
    />
  </View>
);
